import React from "react";
import ModalWrapper from "components/common/ModalWrapper";
import ClickToCopyWrapper from "components/common/ClickToCopyWrapper";

const codeStyle =
  "font-mono text-sm font-semibold text-gray-600 rounded p-1 bg-gray-200";

class AttributeHintModal extends React.Component {
  render() {
    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={true}
        customOverlayStyle={{ zIndex: 100 }}
        handleClose={this.props.handleClose}
        title="Using Specific Attribute for Advanced Search"
      >
        <div className="mt-2 font-semibold text-gray-800">
          Support Attribute
        </div>
        <ul className="list-disc pl-8">
          <li>
            <span className={codeStyle}>{`adUnit`}</span>
          </li>
          <li>
            <span className={codeStyle}>{`extGamUnitId`}</span>
          </li>
          <li>
            <span className={codeStyle}>{`name`}</span>
          </li>
          <li>
            <span className={codeStyle}>{`parentPath`}</span>
          </li>
          <li>
            <span className={codeStyle}>{`siteNetworkCode`}</span>
          </li>
        </ul>

        <div className="mt-2 font-semibold text-gray-800">Exact Match</div>
        <ul className="list-disc pl-8">
          <li>
            <span className={codeStyle}>{`EQUALS`}</span> (returns only the
            records that exactly match the input)
          </li>
          <li>
            Example:{" "}
            <div className="flex items-center">
              <span className={codeStyle}>{`name EQUALS "feed"`}</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`name EQUALS "feed"`}
                ></ClickToCopyWrapper>
              </div>
            </div>
          </li>
        </ul>

        <div className="mt-2 font-semibold text-gray-800">Partial Match</div>
        <ul className="list-disc pl-8">
          <li>
            <span className={codeStyle}>{`CONTAINS`}</span> (returns records
            that contain the input as part of the text)
          </li>
          <li>
            Example:{" "}
            <div className="flex items-center">
              <span className={codeStyle}>{`adUnitId CONTAINS "465"`}</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`adUnitId CONTAINS "465"`}
                ></ClickToCopyWrapper>
              </div>
            </div>
          </li>
        </ul>

        <div className="mt-2 font-semibold text-gray-800">
          Advanced Examples
        </div>
        <ul className="mb-2 list-disc pl-8">
          <li>
            <div className="flex items-center">
              <span
                className={codeStyle}
              >{`(REFRESH == true OR VIDEO_CREATIVE == true) && extGamAdUnitId CONTAINS "465"`}</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`(REFRESH == true OR VIDEO_CREATIVE == true) && extGamAdUnitId CONTAINS "465"`}
                ></ClickToCopyWrapper>
              </div>
            </div>
          </li>
          <li>
            <div className="flex items-center">
              <span
                className={codeStyle}
              >{`IMP_PCT:GOOGLE > 50 && IMP_PCT:GOOGLE < 60 && name EQUALS "abc"`}</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`IMP_PCT:GOOGLE > 50 && IMP_PCT:GOOGLE < 60 && name EQUALS "abc"`}
                ></ClickToCopyWrapper>
              </div>
            </div>
          </li>
        </ul>
      </ModalWrapper>
    );
  }
}

export default AttributeHintModal;
